import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftIcon, HomeIcon } from '@heroicons/react/24/outline';

const StandardNavbar = ({ 
  title = "W3Skills", 
  showBack = true, 
  showHome = false, 
  onBack = null,
  className = "" 
}) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBack) {
      onBack();
    } else {
      navigate(-1);
    }
  };

  const handleHome = () => {
    navigate('/');
  };

  return (
    <nav className={`bg-white shadow-sm border-b ${className}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center space-x-4">
            {showBack && (
              <button
                onClick={handleBack}
                className="flex items-center text-gray-600 hover:text-blue-600 transition-colors"
              >
                <ArrowLeftIcon className="h-5 w-5 mr-2" />
                Back
              </button>
            )}
            {showHome && (
              <button
                onClick={handleHome}
                className="flex items-center text-gray-600 hover:text-blue-600 transition-colors"
              >
                <HomeIcon className="h-5 w-5 mr-2" />
                Home
              </button>
            )}
          </div>
          <div className="flex-shrink-0">
            <h1 className="text-2xl font-bold text-blue-600">{title}</h1>
          </div>
          <div className="flex-shrink-0">
            {/* Right side can be used for additional actions if needed */}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default StandardNavbar;
